const getUpdatedValues = (values, initialValues) => Object.keys(values).reduce((acc, key) => {
    if (values[key] !== initialValues[key]) {
        acc[key] = values[key];
    }
    return acc;
}, {});

export default getUpdatedValues;
